import { ApplicationEventType } from './application-event-type';

export class ApplicationEvent{
    message: string;
    type: ApplicationEventType;
}

export class TypedApplicationEvent<T> extends ApplicationEvent{
    data: T;
}